import { formatPersianNumber } from "../../utils/persianNumber";

export const SEGMENTS = [
  { value: "vip", label: "ویژه", className: "text-amber-700" },
  { value: "regular", label: "ثابت", className: "text-secondary" },
  { value: "new", label: "جدید", className: "text-blue-700" },
  { value: "occasional", label: "گاه‌به‌گاه", className: "text-gray-600" },
  { value: "inactive", label: "غیرفعال", className: "text-red-700" },
];

export const SEGMENT_HINTS = {
  vip: "۱۰ مراجعه یا بیشتر",
  regular: "۳ مراجعه یا بیشتر",
  new: "عضو در ۳۰ روز اخیر",
  occasional: "کمتر از ۳ مراجعه",
  inactive: "بیش از ۶۰ روز بدون مراجعه",
};

export const segmentOf = (value) => SEGMENTS.find((segment) => segment.value === value) || SEGMENTS[3];

export const SOURCE_LABELS = {
  menu: "عضویت از منو",
  reservation: "رزرو",
  order: "سفارش",
  review: "نظر",
  manual: "ثبت دستی",
  club: "باشگاه",
};

export const JALALI_MONTHS = [
  "فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور",
  "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند",
];

const shortDate = new Intl.DateTimeFormat("fa-IR", { year: "numeric", month: "short", day: "numeric" });
const dateTime = new Intl.DateTimeFormat("fa-IR", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });

export const toFa = (value) => formatPersianNumber(Number(value) || 0);

export const formatDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "—" : shortDate.format(date);
};

export const formatDateTime = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "—" : dateTime.format(date);
};

export const formatToman = (value) => `${toFa(value)} تومان`;

// "09121234567" → "۰۹۱۲ ۱۲۳ ۴۵۶۷"
export const formatPhone = (phone = "") => {
  const digits = String(phone);
  const grouped = digits.length === 11 ? `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}` : digits;
  return grouped.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
};

export const formatBirthday = (birthday) => {
  if (!birthday) return "";
  const [month, day] = birthday.split("-").map(Number);
  if (!month || !day) return "";
  return `${toFa(day)} ${JALALI_MONTHS[month - 1]}`;
};

// Relative "last visit" label: today / N days ago / date.
export const formatLastVisit = (value, now = Date.now()) => {
  if (!value) return "هنوز مراجعه‌ای نداشته";
  const days = Math.floor((now - new Date(value).getTime()) / (24 * 60 * 60 * 1000));
  if (days <= 0) return "امروز";
  if (days === 1) return "دیروز";
  if (days < 30) return `${toFa(days)} روز پیش`;
  return formatDate(value);
};

const csvCell = (value) => {
  const text = String(value ?? "");
  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export const customersToCsv = (customers) => {
  const header = ["نام", "موبایل", "گروه", "تعداد مراجعه", "رزرو", "سفارش", "مجموع خرید (تومان)", "آخرین مراجعه", "تاریخ تولد", "برچسب‌ها", "منبع", "رضایت پیامک", "تاریخ عضویت"];
  const rows = customers.map((c) => [
    c.name,
    c.phone,
    segmentOf(c.segment).label,
    c.stats.visitCount,
    c.stats.reservationCount,
    c.stats.orderCount,
    c.stats.totalSpent,
    c.stats.lastVisitAt ? formatDate(c.stats.lastVisitAt) : "",
    formatBirthday(c.birthday),
    (c.tags || []).join("، "),
    SOURCE_LABELS[c.source] || c.source,
    c.marketingConsent ? "بله" : "خیر",
    formatDate(c.createdAt),
  ]);
  // BOM so Excel opens the Persian text correctly.
  return `﻿${[header, ...rows].map((row) => row.map(csvCell).join(",")).join("\n")}`;
};
